import { LoadScript } from "@react-google-maps/api";
import { AutoComplete, Breadcrumb, Col, Form, Input, Row, Spin } from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import EmailField from "../../common/htmlComponents/EmailField";
import InputField from "../../common/htmlComponents/InputField";
import "../../styles/Main.scss";
import {
    SuccessNotificationMsg
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
// import CompanyDepoAddress from "./CompanyDepoAddress";

// const { Option } = Select;

const MyPickupPoint = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const libraries = ["places"];
    // const formRef = useRef();
    const formRef = useRef();
    const [form] = Form.useForm();
    // const { isLoaded, loadError } = useLoadScript({
    //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    //   libraries: ['places'],
    // });
    const { id } = useParams();
    // const PickupPointId = id ? atob(id) : null;
    const PickupPointId = authUserData()?.pickup_point ? authUserData()?.pickup_point : "";

    const [options, setOptions] = useState([]);
    // const { Panel } = Collapse;
    // const [sizepolicecheck, setSizepolicecheck] = useState(null);
    // const [sizeuploaddrivinglicense, setsizeuploaddrivinglicense] =
    //   useState(null);
    const [fileLink, setFileLink] = useState(null);
    const [fileLinkpolice_check, setFileLinkpolice_check] = useState(null);
    // const [fileName, setFileName] = useState(null);
    // const [fileNamepolice_check, setFileNamepolice_check] = useState(null);
    // const [uploadFile, setUploadFile] = useState("");
    // const [uploadFilepolicecheck, setUploadFilepolicecheck] = useState("");

    const initialState = {
        person_name: null,
        email: null,
        phone: null,
        address: null,
        additional_detail: null,
        suburb: null,
        state: null,
        pincode: null
    };
    const [state, setState] = useState(initialState);
    const [btnLoading, setBtnLoading] = useState(false);
    const [apiLoading, setapiloading] = useState(false);
    // const [checked, setChecked] = useState(false);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);
    // const handleCheckboxChange = (e) => {
    //   setChecked(e.target.checked);
    //   setState((prevState) => ({
    //     ...prevState,
    //     term_condition_accept: e.target.checked,
    //   }));
    // };

    const urls = state?.driving_license;
    // const urlone = state.document_url;

    let filenamelicense = "";
    // let filenameadhar = "";
    try {
        if (fileLink) {
            filenamelicense = urls.split("/").pop();
        }
    } catch (e) {
        filenamelicense = "";
    }

    const url = state?.police_check;

    let filenamepolice_check = "";
    try {
        if (fileLinkpolice_check) {
            filenamepolice_check = url.split("/").pop();
        }
    } catch (e) {
        filenamepolice_check = "";
    }
    const setWeightSizeFieldValue = (data) => {
        const fieldObject = {};
        data.forEach((address, index) => {
            fieldObject[`depo_street_address${index}`] = address.depo_street_address;
            fieldObject[`depo_suburb${index}`] = address.depo_suburb;
            fieldObject[`state${index}`] = address.state;
            fieldObject[`postcode${index}`] = address.postcode;
            fieldObject[`additional_details${index}`] = String(address.additional_details);
        });

        formRef.current.setFieldsValue(fieldObject); // Set form values
    };

    useEffect(() => {
        const companyGetById = async () => {
            setapiloading(true);
            try {
                const apiResponse = await getRequest(`pickup-point/${PickupPointId}/`);

                if (apiResponse?.data?.success) {
                    const companyData = apiResponse.data.data;
                    // Set state with initial values
                    const depoAddresses = companyData.depo_address?.map((e) => ({
                        depo_street_address: e?.depo_street_address,
                        depo_suburb: e?.depo_suburb,
                        depo_state: e?.depo_state,
                        depo_postcode: e?.depo_postcode,
                        depo_additional_details: e?.depo_additional_details,
                    })) || [];
                    setState({
                        ...apiResponse?.data?.data,
                        person_name: apiResponse?.data?.data?.person_name,
                        email: apiResponse?.data?.data?.email,
                        phone: String(apiResponse?.data?.data?.phone),
                        state: apiResponse?.data?.data?.state,
                        suburb: apiResponse?.data?.data?.suburb,
                        pincode: apiResponse?.data?.data?.pincode,
                        address: apiResponse?.data?.data?.address,

                        additional_detail: apiResponse?.data?.data?.additional_detail,
                        // depo_address: apiResponse?.data?.data?.depo_address?.map((e) => ({
                        //   street_address: e?.street_address,
                        //   suburb: e?.suburb,
                        //   state: e?.state,
                        //   postcode: e?.postcode,
                        //   additional_details: e?.additional_details,
                        // })),
                    });


                    formRef.current.setFieldsValue({
                        ...apiResponse?.data?.data,
                        person_name: apiResponse?.data?.data?.person_name,
                        email: apiResponse?.data?.data?.email,
                        phone: String(apiResponse?.data?.data?.phone),
                        state: apiResponse?.data?.data?.state,
                        suburb: apiResponse?.data?.data?.suburb,
                        address: apiResponse?.data?.data?.address,
                        pincode: apiResponse?.data?.data?.pincode,
                        additional_detail: apiResponse?.data?.data?.additional_detail,
                        // depo_address: apiResponse?.data?.data?.depo_address?.map((e) => ({
                        //   street_address: e?.street_address,
                        //   suburb: e?.suburb,
                        //   state: e?.state,
                        //   postcode: e?.postcode,
                        //   additional_details: e?.additional_details,
                        // })),
                        // depo_address: apiResponse?.data?.data?.depo_address?.map((e, index) => ({
                        //   [`street_address${index}`]: e?.street_address,
                        //   [`suburb_${0}`]: e?.suburb,
                        //   [`state_${0}`]: e?.state,
                        //   [`postcode_${0}`]: e?.postcode,
                        //   [`additional_details_${0}`]: e?.additional_details,
                        // })),
                    });

                    formRef.current.setFieldsValue({
                        ...companyData,
                        company_number: String(companyData.company_number),
                        depo_address: depoAddresses,
                    });

                    setWeightSizeFieldValue(depoAddresses);
                    setapiloading(false);
                }
            } catch (error) {
                setapiloading(false);
            }
        };
        if (PickupPointId !== null) {
            companyGetById();
        }

    }, [PickupPointId, t, reload]);

    const handleSelect = (value) => {
        const selected = options.find((option) => option.value === value);
        if (selected && selected.place_id) {
            const service = new window.google.maps.places.PlacesService(
                document.createElement("div")
            );
            service.getDetails({ placeId: selected.place_id }, (place, status) => {
                if (
                    status === window.google.maps.places.PlacesServiceStatus.OK &&
                    place
                ) {
                    setState((prevstate) => ({
                        ...prevstate,
                        address: place.formatted_address,
                        suburb:
                            place.address_components.find((ac) =>
                                ac.types.includes("locality")
                            )?.long_name || "",
                        state:
                            place.address_components.find((ac) =>
                                ac.types.includes("administrative_area_level_1")
                            )?.short_name || "",
                        pincode:
                            place.address_components.find((ac) =>
                                ac.types.includes("postal_code")
                            )?.long_name || "",

                    }));
                    form.setFieldsValue({
                        address: place.formatted_address,
                        suburb:
                            place.address_components.find((ac) =>
                                ac.types.includes("locality")
                            )?.long_name || "",
                        state:
                            place.address_components.find((ac) =>
                                ac.types.includes("administrative_area_level_1")
                            )?.short_name || "",
                        pincode:
                            place.address_components.find((ac) =>
                                ac.types.includes("postal_code")
                            )?.long_name || "",
                    });
                }
            });
        }
    };

    const handleSearch = useCallback(
        debounce((value) => {
            // setLoading(true);

            const service = new window.google.maps.places.AutocompleteService();

            if (value !== "") {
                service.getPlacePredictions({ input: value }, (predictions, status) => {
                    if (
                        status === window.google.maps.places.PlacesServiceStatus.OK &&
                        predictions
                    ) {
                        setOptions(
                            predictions.map((prediction) => ({
                                value: prediction.description,
                                place_id: prediction.place_id,
                            }))
                        );
                        setLoading(false);
                    } else {
                        setOptions([]);
                        setLoading(false);
                    }
                });
            } else {
                setOptions([]);
                setLoading(false);
                setState((prevstate) => ({
                    ...prevstate,
                    address: "",
                    suburb: "",
                    state: "",
                    pincode: "",
                }));
                form.setFieldsValue({
                    address: "",
                    suburb: "",
                    state: "",
                    pincode: "",
                });
            }
        }, 300),
        []
    );

    const handleInputChange = (e) => {
        let { name, value } = e.target;
        setState({ ...state, [name]: value });
    };
    const handleInputChangeEmail = (e) => {
        let { name, value } = e.target;
        // setState({ ...state, [name]: value });
        setState({ ...state, [name]: value.toLowerCase() });
    };
    const handleKeyPress = (e) => {
        // Allow only lowercase letters, numbers, and specific symbols
        const allowedChars = /^[a-z0-9@._-]*$/; // Add other allowed characters as needed
        if (!allowedChars.test(e.key) && e.key !== 'Backspace') {
            e.preventDefault();
        }
    };



    const phoneValidLength = state.number;

    const validatePhoneNumber = () => {
        if (
            (phoneValidLength && phoneValidLength.length < 8) ||
            phoneValidLength === null ||
            phoneValidLength === ""
        ) {
            return Promise.reject(new Error("Please enter valid phone."));
        }

        return Promise.resolve();
    };

    const handleSubmit = async () => {

        const payload = {
            person_name: state.person_name,
            email: state.email,
            phone: state.phone,
            address: state.address,
            additional_detail: state.additional_detail,
            suburb: state.suburb,
            state: state.state,
            pincode: state.pincode,
        };
        try {
            setBtnLoading(true);
            let response;

            if (PickupPointId === null) {
                response = await postRequest("pickup-point/", payload,);
            } else {
                response = await patchRequest(`pickup-point/${PickupPointId}/`, payload);
            }
            if (response.data.success) {
                SuccessNotificationMsg(
                    PickupPointId === null
                        ? t("pickuppoint_added_successfully")
                        : t("pickuppoint_updated_successfully")
                );
                // setState(initialState);
                // formRef.current.setFieldsValue(initialState);
                setBtnLoading(false);
                setReload(!reload);


                //navigate("/pickup-point");
            }

        } catch (error) {
            // if (CompanyId === null) {
            //   ErrorNotificationMsg(
            //     t("error_in_adding_company")
            //   );
            // }
            // if (CompanyId !== null && !error?.message) {
            //   ErrorNotificationMsg(
            //     t("error_in_updating_company")
            //   );
            // }
            setBtnLoading(false);
        }
    };


    return (
        <>
            <div className="ListingTopBar">
                <div className="pagenamewrap">
                    <div className="pagename">
                        {/* {PickupPointId ? <h3>Edit Pickup Point</h3> : <h3>Add Pickup Point</h3>} */}
                        <h3> {t("Pickup Point")} </h3>
                        <Breadcrumb className="Breadcrumb-Sec">
                            <Breadcrumb.Item>
                                <Link to="/dashboard">{t("home")}</Link>
                            </Breadcrumb.Item>
                            {/* <Breadcrumb.Item>
                <Link to="/pickup-point">
                  {" "}
                  {t("Pickup Point")}
                </Link>
              </Breadcrumb.Item> */}

                            <Breadcrumb.Item>
                                {/* {PickupPointId ? "Edit Pickup Point" : "Add Pickup Point"} */}
                                {t("Pickup Point")}
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </div>

            <section className="grid-sec FormSection Container">
                <div className="FormBody">
                    <Form ref={formRef} form={form} >
                        <LoadScript
                            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                            libraries={libraries}
                        >

                            <Spin spinning={apiLoading}>
                                {/* <Form autoComplete="off" form={form} > */}

                                {/* <Collapse defaultActiveKey={["1"]}> */}
                                {/* <Panel
                    header="1. Company Basic Details"
                    key="1"
                  > */}
                                <Row gutter={[10]}>
                                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                                        {/* <InputField
                          name="company_name"
                          label={t("company_name")}
                          placeholder={t("pl_client_name")}
                          rules={t("val_name")}
                          value={state?.company_name}
                          // pattern={"^[a-zA-Z ]+$"}
                          pattern={"^[a-zA-Z0-9\\s]+$"}
                          // prefix={<Name />}
                          handleInputChange={handleInputChange}
                          max={30}
                        /> */}
                                        <InputField
                                            name="person_name"
                                            label={t("Person Name")}
                                            placeholder={t("Enter Person Name")}
                                            rules={t("Please Enter Person Name")}
                                            value={state.person_name}
                                            // prefix={<Company />}
                                            handleInputChange={handleInputChange}
                                            max={30}
                                        />
                                    </Col>

                                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                                        <EmailField
                                            name="email"
                                            label={t("label_email")}
                                            placeholder={t("Enter Person Email")}
                                            rules={t("val_email")}
                                            value={state?.email}
                                            disabled
                                            // prefix={<Email />}
                                            handleInputChange={handleInputChangeEmail}
                                            onKeyPress={handleKeyPress}
                                        />
                                    </Col>

                                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                                        <Form.Item
                                            name="phone"
                                            label={t("Person Number")}
                                            disabled
                                            placeholder={t("Enter Person Number")}
                                            rules={[
                                                {
                                                    required: true,
                                                    validator: validatePhoneNumber,
                                                    message: (<Trans> {t("Please Enter Person Number")}</Trans>),
                                                },
                                            ]}

                                        >
                                            <PhoneInput
                                                disabled
                                                // country={"in"}
                                                country={"au"}
                                                className="PhoneSection"
                                                value={state?.phone}
                                                onChange={(phone) => setState({ ...state, phone: phone })}
                                            />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                                        <Form.Item
                                            name="address"
                                            label={t("Address")}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: (
                                                        <Trans>
                                                            {t("Search Address")}
                                                        </Trans>
                                                    ),
                                                },
                                            ]}
                                        >
                                            <AutoComplete
                                                id="address"
                                                placeholder={t("Search Address")}
                                                options={options}
                                                onSearch={handleSearch}
                                                onSelect={handleSelect}
                                                value={state.address}
                                                onChange={(value) => {
                                                    setState((prevstate) => ({
                                                        ...prevstate,
                                                        address: value,
                                                    }));
                                                    form?.setFieldsValue({
                                                        address: value,
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                                        <Form.Item
                                            name="additional_detail"
                                            label={t("additional_details")}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: (
                                                        <Trans>
                                                            {t("pl_enter_additional_detail")}
                                                        </Trans>
                                                    ),
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder={t("enter_additional_details")}
                                                name="additional_detail"
                                                value={state.additional_detail}
                                                onChange={(e) => {
                                                    const { value } = e.target;
                                                    setState((prevstate) => ({
                                                        ...prevstate,
                                                        additional_detail: value,
                                                    }));
                                                    form.setFieldsValue({
                                                        additional_detail: value,
                                                    });
                                                }}
                                            // Adjust the number of rows as needed
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">

                                        <Form.Item
                                            name="suburb"
                                            label={t("pl_suburb")}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: (
                                                        <Trans>{t("val_suburb")}</Trans>
                                                    ),
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder={t("pl_enter_suburb")}
                                                name="suburb"
                                                value={state.suburb}
                                                onChange={(e) => {
                                                    const { value } = e.target;
                                                    setState((prevstate) => ({
                                                        ...prevstate,
                                                        suburb: value,
                                                    }));
                                                    form.setFieldsValue({
                                                        suburb: value,
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">

                                        <Form.Item
                                            name="state"
                                            label={t("pl_state")}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: (
                                                        <Trans>{t("val_state")}</Trans>
                                                    ),
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder={t("pl_enter_state")}
                                                name="state"
                                                value={state.state}
                                                onChange={(e) => {
                                                    const { value } = e.target;
                                                    setState((prevstate) => ({
                                                        ...prevstate,
                                                        state: value,
                                                    }));
                                                    form.setFieldsValue({
                                                        state: value,
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                                        <Form.Item
                                            name="pincode"
                                            label={t("pl_Postcode")}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: (
                                                        <Trans>{t("val_Postcode")}</Trans>
                                                    ),
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder={t("pl_enter_postcode")}
                                                name="pincode"
                                                value={state.pincode}
                                                onChange={(e) => {
                                                    const { value } = e.target;
                                                    setState((prevstate) => ({
                                                        ...prevstate,
                                                        pincode: value,
                                                    }));
                                                    form.setFieldsValue({
                                                        pincode: value,
                                                    });
                                                }}
                                            />
                                        </Form.Item>
                                    </Col>
                                    {/* <Col xs={24} sm={24} md={24} lg={4} xl={4} className="TextFeild">
                        <InputField
                          name="company_note"
                          label={t("label_note")}
                          placeholder={t("pl_note")}
                           rules={t("val_note_2")}
                          // nonRequiredRules={t("val_note_2")}
                          //pattern={"^\\d{8,9}$"} // Pattern for 8 or 9 digits
                          value={state?.company_note}
                          // prefix={<Company />}
                          handleInputChange={handleInputChange}
                          max={30}
                        />
                      </Col> */}



                                </Row>
                                {/* </Panel> */}
                                {/* </Collapse> */}

                                <div className="FormFooter">
                                    {/* <ButtonField
                    className="CancelGradiantBtn"
                    type="primary"
                    htmlType="button"
                    size="medium"
                    label="Cancel"
                     onClick={() => navigate("/pickup-point")}
                  /> */}
                                    <ButtonField
                                        className="SaveGradiantBtn"
                                        type="primary"
                                        htmlType="submit"
                                        label="Save"
                                        onClick={handleSubmit}
                                        // disabled={!checked || btnLoading}
                                        loading={btnLoading}
                                    />
                                </div>

                                {/* </Form> */}
                            </Spin>
                        </LoadScript>
                    </Form>
                </div>
            </section >
        </>
    );
};

export default MyPickupPoint;
